'use strict';

angular.module('mobile-apps')
	.directive('displayTags',['$rootScope', '$compile', '$state', '$http', '$templateCache', function($rootScope, $compile, $state, $http, $templateCache) {
		return {
			scope:
			{
				allTags : '=',
				entryId : '@', // Optional
				entryTags : '=',
				tagCategories : '='
			},
			templateUrl: 'modules/mobile-apps/views/display-tags.client.directive.html',

			link: function (scope, elem, attrs) {
				scope.displayTags = [];

				scope.entryTags.forEach(function(tagId) {
					if (scope.allTags && scope.allTags.hasOwnProperty(tagId)) {
						scope.displayTags.push(scope.allTags[tagId]);
					}
				});

				scope.$on('addedJiraTag', function (event, data) {
					if(data.entryDescIds.includes(scope.entryId)) {
						scope.entryTags.push(data.tag._id)
						scope.allTags[data.tag._id] = data.tag;
						scope.displayTags.push(data.tag);
					}
				});

			}
		};
	}]);
